// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__VbqWl","imageUploader":"EGiftCard_imageUploader__3565A"};